import { useGLTF } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { ObjectLoader } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';
import './common-DBpCdW70.esm.js';

const Graph = () => {
  const model = useGLTF(defineSrc('graph.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('graph-light.json'));
  useFrame(() => {
    const {
      offset
    } = model.materials['Standard '].map;
    offset.x += -15e-4;
    offset.y += 0.0015;
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      scale: 1.3,
      position: [0, -10, 0],
      object: model.scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Graph as default };
//# sourceMappingURL=Graph-CFMO57zZ.esm.js.map
